class Utils {
    /**
     * 设置cookie
     * @param {Object} name
     * @param {Object} value
     * @param {Object} day
     */
    setCookie(name, value, day) {
        let expires = '';
        if (day) {
            const date = new Date();
            date.setTime(date.getTime() + (day * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }

    // 退出登录
    logout(store, router) {
        store.commit("SET_LOGIN", false);
        this.clearCookie("token");
        store.commit("SET_TOKEN", false);
        store.commit("SET_USERINFO", {});
        store.commit("SET_IS_CHECK", '');

        if (router && router.path !== '/') {
            router.replace("/")
        }
    };

    /**
     * 获取cookie
     * @param {Object} name
     */
    getCookie(name) {
        let cookies = document.cookie.split('; ');
        for (let i = 0; i < cookies.length; i++) {
            let parts = cookies[i].split('=');
            if (parts[0] === name) {
                return parts[1];
            }
        }
        return '';
    }

    /**
     * 清除cookie
     * @param {Object} name
     */
    clearCookie(name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

// 获取当前页面的URL
    getFullPath() {
        return window.location.href;
    }

// 数组处理
    handleArray(arr, chunkSize) {
        const result = [];
        for (let i = 0; i < arr.length; i += chunkSize) {
            result.push(arr.slice(i, i + chunkSize));
        }
        return result;
    }

    /**
     * 判断是否为空
     * @param {Object} value
     */
    isEmpty(value) {
        if (value != "" && value != undefined && value != null) {
            return false;
        } else {
            return true;
        }
    }

// 判断是否是手机端
    isMobile() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    }

    /**
     * 金额格式化
     * @param {Object} price
     */
    formatPrice(price) {
        if (price.length > 6) {
            return (price / 10000).toFixed(2) + "万";
        } else {
            return price;
        }
    }

    /**
     * 手机号脱敏
     * @param {Object} phoneNumber
     */
    maskPhoneNumber(phoneNumber) {
        if (phoneNumber){
        return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
        }else{
            return phoneNumber
        }
    }

    /**
     * 微信号脱敏
     * @param {Object} weChatID
     */
    desensitizeWeChatID(weChatID) {
        // 检查微信号长度，‌如果长度小于等于某个阈值（‌例如7）‌，‌则不需要脱敏，‌直接返回原始微信号
        if (weChatID.length <= 7) {
            return weChatID;
        }

        // 定义脱敏填充字符，‌默认为'*'
        const fillChar = '*';

        // 构造脱敏后的微信号字符串
        let desensitizedWeChatID = '';
        for (let i = 0; i < weChatID.length; i++) {
            // 根据索引位置决定是否填充'*'
            if (i < 4 || i > weChatID.length - 4) {
                desensitizedWeChatID += weChatID[i]; // 保留前4位和后4位字符
            } else {
                desensitizedWeChatID += fillChar; // 其他位置用'*'填充
            }
        }

        return desensitizedWeChatID;
    }

// 复制文本
    copyText(text, that) {
        navigator.clipboard
            .writeText(text)
            .then(() => {
                if (that && that.$message) {
                    that.$message.success({
                        message: "已复制到剪贴板",
                        duration: 2000,
                        offset: 200,
                    });
                } else {
                    // 降级方案：使用alert或者console.log
                    console.log("已复制到剪贴板");
                }
            })
            .catch(() => {
                // 降级方案
                const textArea = document.createElement("textarea");
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);
                if (that && that.$message) {
                    that.$message.success({
                        message: "已复制到剪贴板",
                        duration: 2000,
                        offset: 200,
                    });
                } else {
                    // 降级方案：使用alert或者console.log
                    console.log("已复制到剪贴板");
                }
            });
    }

}

/**
 * 动态计算滚动条宽度
 * @returns {number} 滚动条宽度
 */
export function getScrollbarWidth() {
  // 创建一个临时div来测量滚动条宽度
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  outer.style.msOverflowStyle = 'scrollbar'; // IE
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // 清理临时元素
  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
}

/**
 * 获取滚动条高度
 * @returns {number} 滚动条高度
 */
export function getScrollbarHeight() {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  outer.style.msOverflowStyle = 'scrollbar';
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  const scrollbarHeight = outer.offsetHeight - inner.offsetHeight;

  outer.parentNode.removeChild(outer);

  return scrollbarHeight;
}

/**
 * 设置CSS变量来动态控制滚动条宽度
 */
export function setScrollbarCSSVariables() {
  const scrollbarWidth = getScrollbarWidth();
  const scrollbarHeight = getScrollbarHeight();

  // 设置CSS变量
  document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
  document.documentElement.style.setProperty('--scrollbar-height', `${scrollbarHeight}px`);

  // 根据滚动条宽度设置不同的样式类
  if (scrollbarWidth > 0) {
    document.documentElement.classList.add('has-scrollbar');
    document.documentElement.classList.remove('no-scrollbar');
  } else {
    document.documentElement.classList.add('no-scrollbar');
    document.documentElement.classList.remove('has-scrollbar');
  }

  return { width: scrollbarWidth, height: scrollbarHeight };
}

/**
 * 监听窗口大小变化，动态更新滚动条宽度
 */
export function initScrollbarObserver() {
  // 初始化设置
  setScrollbarCSSVariables();

  // 监听窗口大小变化
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      setScrollbarCSSVariables();
    }, 100);
  });

  // 监听方向变化（移动设备）
  window.addEventListener('orientationchange', () => {
    setTimeout(() => {
      setScrollbarCSSVariables();
    }, 100);
  });
}

/**
 * 获取当前滚动条宽度
 * @returns {number}
 */
export function getCurrentScrollbarWidth() {
  return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--scrollbar-width')) || 0;
}

/**
 * 检查是否显示滚动条
 * @returns {boolean}
 */
export function hasScrollbar() {
  return document.documentElement.classList.contains('has-scrollbar');
}

/**
 * 刷新页面滚动到顶部
 * @param {boolean} smooth 是否使用平滑滚动
 */
export function resetPageScroll(smooth = true) {
  if (smooth) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  } else {
    window.scrollTo(0, 0);
  }
}

/**
 * 滚动到指定元素
 * @param {string} selector 元素选择器
 * @param {number} offset 偏移量
 * @param {boolean} smooth 是否使用平滑滚动
 */
export function scrollToElement(selector, offset = 0, smooth = true) {
  const element = document.querySelector(selector);
  if (element) {
    const elementTop = element.offsetTop - offset;
    if (smooth) {
      window.scrollTo({
        top: elementTop,
        left: 0,
        behavior: 'smooth'
      });
    } else {
      window.scrollTo(0, elementTop);
    }
  }
}

export default Utils;
